import { render, staticRenderFns } from "./VerificarEmail.vue?vue&type=template&id=2402e8d0&"
import script from "./VerificarEmail.vue?vue&type=script&lang=js&"
export * from "./VerificarEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports